import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
  ApDynformsConfigFieldset
}                                                               from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {BehaviorSubject, Subscription}                          from 'rxjs';
import {FormStore, IEntryComponent}                             from '../../stores/layout/form.store';
import {
  ApDynformsConfigNumerictextbox
}                                                               from '../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {
  ApDynformsConfigComboBox
}                                                               from '../../ap-dynforms/config/ap-dynforms-config-combobox';
import {distinctUntilChanged, map}                              from 'rxjs/operators';
import {
  NFertilizationStore
}                                                               from '../../stores/n-fertilization/n-fertilization.store';
import {
  ApNFertilizationComponentService
}                                                               from '../../n-fertilization/services/ap-n-fertilization-component.service';
import {ObjectFactory}                                          from 'ts-tooling';
import {FertilizerStore}                                        from '../../stores/base-data/fertilizer.store';
import {LanguageStore}                                          from '../../stores/translation/language.store';
import {ApDynformsValidator}                                    from '../../ap-dynforms/ap-dynforms-validator';
import {Validators}                                             from '@angular/forms';
import {DriverStore}                                            from '../../stores/docu/driver.store';
import {InstrumentStore}                                        from '../../stores/docu/instrument.store';
import {MachineStore}                                           from '../../stores/docu/machine.store';
import {AgriportConstantsService}                               from '../../services/common/agriport-constants.service';
import {
  GeneralConfig
}                                                               from './ap-n-fertilization-planning-configs/general.config';
import {TranslationStore}                                       from '../../stores/translation/translation.store';
import {
  GetOperationModeService
}                                                               from '../../ap-utils/service/ap-get-operationmode.service';
import {ApDateService}                                          from '../../ap-core/services/ap-date-service';
import {
  ApDynformsConfigTextbox
}                                                               from '../../ap-dynforms/config/ap-dynforms-config-textbox';
import {SettingsStore}                                          from '../../stores/base-data/settings.store';
import {GetRoundNumericService}                                 from '../../ap-utils/service/get-round-numeric.service';
import {FieldStore}                                             from '../../stores/farm/field.store';
import {ApDynformsComponent}                                    from '../../ap-dynforms/ap-dynforms.component';
import {UnitsStore}                                             from '../../stores/common/units.store';
import {OperationModesEnum, OperationModesStore}                from '../../stores/common/operation-modes.store';
import {LogfileService}                                         from '../../services/data/logfiles.service';
import {
  NFertilizationLogfilesGridData
}                                                               from '../../n-fertilization/types/n-fertilization-logfiles.types';
import {
  NFertilizationPlanningEntryService
}                                                               from './services/n-fertilization-planning-entry.service';
import IDatasetFieldMap = Data.Sensor.IDatasetFieldMap;
import INFertilizationPlanBook = Data.TaskManagement.INFertilizationPlanBook;
import INFertilizationSummary = Data.TaskManagement.INFertilizationSummary;

@Component({
  selector: 'ap-n-fertilization-logfile-edit',
  template: `
    <ap-dynforms
      [fieldsets]="fieldSets$ | async"
    >
      <div class="ap-form-actions" dynforms.action>
        <button id="button_prev"
                type="button"
                kendoButton class="ap-form-button-left"
                (apSingleClick)="onCancelClick()">
          {{ 'Global_Back_With_Arrow' | translate }}
        </button>
        <button id="button_next"
                type="button"
                [disabled]="saveDisabled$ | async"
                kendoButton [themeColor]="'primary'" class="ap-form-button-right"
                (apSingleClick)="onSaveClick()">
          {{ 'Global__Save' | translate }}
        </button>
      </div>
    </ap-dynforms>
  `,
  styles: [],
  standalone: false,
  providers: [
    GeneralConfig,
    NFertilizationPlanningEntryService
  ]
})
export class ApNFertilizationLogfileEditComponent implements OnInit, AfterViewInit, OnDestroy, IEntryComponent {
  /**
   * Implements IEntryComponent
   */
  public Caption$: BehaviorSubject<string> = new BehaviorSubject('Docu_Ini__Edit');
  // @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  @ViewChild(ApDynformsComponent, {static: true}) public dynForm: ApDynformsComponent;

  fieldSets$ = new BehaviorSubject<ApDynformsConfigFieldset[]>([]);
  saveDisabled$ = new BehaviorSubject<boolean>(false);
  logFile: IDatasetFieldMap;
  private _subscriptions: Subscription[] = [];
  private formValuesUpdateInProgress = false;

  constructor(private componentService: ApNFertilizationComponentService,
              private constantsService: AgriportConstantsService,
              private dateService: ApDateService,
              private driverStore: DriverStore,
              private fertilizerStore: FertilizerStore,
              private fieldStore: FieldStore,
              private formBuilder: GeneralConfig,
              private formStore: FormStore,
              private instrumentStore: InstrumentStore,
              private languageStore: LanguageStore,
              private machineStore: MachineStore,
              private nFertilizationStore: NFertilizationStore,
              private operationModeService: GetOperationModeService,
              private operationModeStore: OperationModesStore,
              private roundNumericService: GetRoundNumericService,
              private settings: SettingsStore,
              private translationStore: TranslationStore,
              private unitStore: UnitsStore,
              private logfilesService: LogfileService) {
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach((s) => s.unsubscribe());
  }

  public ngOnInit(): void {
    this.logFile = ObjectFactory.Copy(this.formStore.Listen(s => s.updateComponent).getValue().data.SourceItem);
    const dataItem = ObjectFactory.Copy(this.formStore.Listen(s => s.updateComponent).getValue().data);
    dataItem['Planning'] = this.nFertilizationStore.GetPlanningById(dataItem['Planning']?.Id);
    // TODO: cannot use previous type NFertilizationLogfilesGridData->Planning, align
    // Problem is in grid assigning, ap-n-fertilization-logfiles.component.ts:586
    // (Assigning Planning object content from different places)

    this._subscriptions.push(this.dynForm.FormValues$.pipe(
      distinctUntilChanged((previous, current) => JSON.stringify(previous) === JSON.stringify(current)))
      .subscribe((values) => dataItem.Ec = values['Ec']));

    this.fieldSets$.next(this.getFieldSets(dataItem as NFertilizationLogfilesGridData));
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.dynForm.form.markAllAsTouched();
      this.saveDisabled$.next(!this.dynForm.form.valid);
    }, 0);

    this._subscriptions.push(this.dynForm.form.valueChanges.subscribe(() => {
      this.saveDisabled$.next(!this.dynForm.form.valid);
    }));

    for (const key in this.dynForm.form.controls) {
      if (!this.dynForm.form.controls.hasOwnProperty(key)) {
        continue;
      }
      this._subscriptions.push(this.dynForm.form.controls[key].valueChanges.subscribe((v) => {
        this._onFormValueChanges(key, v);
      }));
    }
  }

  private getFieldSets(dataItem: NFertilizationLogfilesGridData): ApDynformsConfigFieldset[] {
    let productId = dataItem.Planning?.ProductId;
    const isScanBoniturOperationMode = dataItem.OperationMode === this.operationModeStore.getIOperationModeByKey(OperationModesEnum.Bonitur)?.LoggerId.toString();
    let group = -1;
    if (productId == null) {
      if (dataItem.NContent === 100) {
        productId = 0;
      } else {
        productId = this.componentService.getProductIdByNContent(dataItem.NContent);
        group = this.fertilizerStore.getGroup(productId);
      }
    } else {
      group = this.fertilizerStore.getGroup(productId);
    }

    const plannings$ = this.nFertilizationStore.PlanBooks$
      .pipe(
        map((planBooks) => this.componentService.convertPlansForLogfiles([this.logFile], planBooks,
          true))
      );

    return [
      new ApDynformsConfigFieldset({
        key: 'Global__General_Information',
        legend: 'Global__General_Information',
        config: [
          new ApDynformsConfigTextbox({
            key: 'FieldName',
            label: 'Global__FieldName',
            disabled: true,
            value: this.fieldStore.getFieldNameById(dataItem?.FieldGeomId)
          }),
          new ApDynformsConfigTextbox({
            key: 'FieldArea',
            label: 'Global_Traversed_Area',
            disabled: true,
            value: this.roundNumericService.round(dataItem?.WorkedArea, this.settings.FirstSetting.DigitsAfterDecimalPoint)
          }),
        ]
      }),
      new ApDynformsConfigFieldset({
        key: 'Logfile',
        legend: 'N__Logfile',
        config: [
          new ApDynformsConfigNumerictextbox({
            key: 'Ec',
            label: 'Global__ECStageShort',
            value: dataItem.SourceItem.Ec,
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: ''}),
            ],
            decimals: 0,
            min: +this.constantsService.GetConstant('EC_MIN'),
            max: +this.constantsService.GetConstant('EC_MAX'),
          }),
          new ApDynformsConfigComboBox({
            key: 'Planning',
            label: 'Global__Planning',
            groupFunction: (planning) =>
              planning.BookedBy == null && planning.BookedAt == null ?
                [this.translationStore.FindTranslationForSelectedLanguage('Nutrients__Not_Booked'), 0] :
                [this.translationStore.FindTranslationForSelectedLanguage('Nutrients__Booked'), 1],
            valuePrimitive: false,
            valueField: 'Id',
            textField: 'Note',
            value$: plannings$.pipe(
              map((plannings) =>
                plannings.find((planning) => planning.Id === dataItem.Planning?.Id)
              )
            ),
            options: plannings$,
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: ''}),
            ]
          }),
          new ApDynformsConfigNumerictextbox({
            key: 'WorkingWidth',
            label: 'Docu_Ini__WorkingWidth_m',
            value: dataItem.WorkingWidth,
            min: 0,
            max: 100,
          }),
          new ApDynformsConfigNumerictextbox({
            key: 'NContent',
            label: 'Global__N_Content_Percent',
            value: dataItem.NContent,
            min: 0,
            max: 100,
            disabled: true
          }),
          new ApDynformsConfigNumerictextbox({
            key: 'NContentAvg',
            label: 'Nutrients__Average_Amount_kg_N_per_ha',
            value: dataItem.Amount?.Avg,
            value$: this.dynForm.FormValues$.pipe(
              map((value) => +value['Amount']),
              distinctUntilChanged(),
              map((value) => this.logfilesService.calculateLogFileAmountNPerHaFromProduct(value, dataItem?.WorkedArea, dataItem?.NContent)),
            ),
            decimals: this.settings.FirstSetting.DigitsAfterDecimalPoint,
            disabled: true
          }),
          new ApDynformsConfigNumerictextbox({
            key: 'Amount',
            label: 'Global__Sum_Goods_kg',
            value: this.logfilesService.calculateLogFileProductFromAmountNPerHa(dataItem.Amount?.Avg, dataItem?.WorkedArea, dataItem?.NContent),
            step: 1,
            min: 0,
            max: this.roundNumericService.roundAsNumber(this.logfilesService.calculateLogFileProductFromAmountNPerHa(200, dataItem?.WorkedArea, dataItem?.NContent)),
            decimals: 0,
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: ''}),
            ]
          })
        ]
      }),
      isScanBoniturOperationMode ? undefined : this.formBuilder.getProductFieldSet({
        Product: productId,
        Group: group
      }, this.dynForm.FormValues$),
      new ApDynformsConfigFieldset({
        key: 'Documentation',
        legend: 'Settings__Lbl_Menu_Resources',
        config: [
          new ApDynformsConfigComboBox({
            key: 'Machine',
            label: 'AgriConnect__Engine',
            value$: this.dynForm.FormValues$.pipe(
              distinctUntilChanged((p, n) => p['Planning']?.Id === n['Planning']?.Id),
              map((v) => v['Planning']?.ExportMachine),
            ),
            disabled$: this.dynForm.FormValues$.pipe(map((values) => !values['Planning'])),
            valueField: 'Id',
            textField: 'NameWithSign',
            sort: 1,
            options: this.machineStore.Listen(s => s.data)
          }),
          new ApDynformsConfigComboBox({
            key: 'Instrument',
            label: 'AgriConnect_Ini__Tool',
            value$: this.dynForm.FormValues$.pipe(
              distinctUntilChanged((p, n) => p['Planning']?.Id === n['Planning']?.Id),
              map((v) => v['Planning']?.ExportInstrument),
            ),
            disabled$: this.dynForm.FormValues$.pipe(map((values) => !values['Planning'])),
            valueField: 'Id',
            textField: 'Name',
            sort: 1,
            options: this.instrumentStore.Listen(s => s.data)
          }),
          new ApDynformsConfigComboBox({
            key: 'Driver',
            value$: this.dynForm.FormValues$.pipe(
              distinctUntilChanged((p, n) => p['Planning']?.Id === n['Planning']?.Id),
              map((v) => v['Planning']?.ExportDriver),
            ),
            label: 'Docu_Ini__Motorist',
            disabled$: this.dynForm.FormValues$.pipe(map((values) => !values['Planning'])),
            valueField: 'Id',
            textField: 'FirstNameFullName',
            sort: 1,
            options: this.driverStore.Listen(s => s.data)
          }),
        ]
      })
    ];
  }

  onCancelClick(): void {
    this.formStore.closeForm();
  }

  onSaveClick(): void {
    if (this.dynForm.form.valid) {
      this._save();
      this.formStore.closeForm();
    } else {
      this.dynForm.markAsTouched();
    }
  }

  _save(): void {
    const values = this.dynForm.form.getRawValue();
    if (values['Planning'].Id === '0') {
      this.logFile.NPlanBook = this._newPlanning();
    } else {
      this.logFile.NPlanBook = values['Planning'];
    }
    this.logFile.NPlanBook.ExportDriver = values.Driver;
    this.logFile.NPlanBook.ExportMachine = values.Machine;
    this.logFile.NPlanBook.ExportInstrument = values.Instrument;
    this.logFile.NPlanBook.ProductId = values.Product ?? 0;
    this.logFile.NContent = this.logFile.NContent == null ? this.logfilesService.calculateLogFileProductFromAmountNPerHa(this.logFile.NContentAvg, this.logFile.Area, 100) : this.logFile.NContent;
    this.logFile.Ec = values.Ec;
    this.logFile.WorkingWidth = values.WorkingWidth;
    this.logFile.Amount = this.logfilesService.calculateLogFileAmountNFromProduct(values['Amount'], values.NContent);
    this.logFile.Factor = this.logfilesService.calculateLogFileFactor(values['Amount'], this.logFile.NContentAvg, this.logFile.Area, values.NContent);
    this.nFertilizationStore.SaveLogfiles([this.logFile]);
  }

  _newPlanning(): INFertilizationPlanBook {

    const json = JSON.parse(this.logFile.DataSet.HeaderValuesString);
    const threshold = json['Relative cutoff'];
    const operationMode = this.operationModeService.GetOperationModeByLoggerId(+json['OperationMode']);
    const applicationMode = this.operationModeService.GetApplicationMode(operationMode);
    const standard = json && json['Standard'] ? +json['Standard'] : (this.logFile.NContentMin + this.logFile.NContentMax) / 2;
    const referenceRate = json['ReferenceRate'] != null ? json['ReferenceRate'].Split(' ')[0] : undefined;
    const applicationRate = referenceRate ? +referenceRate : standard;
    const dateString = this.dateService.toFarmDate(new Date()).format(this.languageStore.CurrentDateTimeFormat);

    const summary = {
      Id: undefined,
      ECValue: this.logFile.Ec,
      OperationMode: operationMode,
      ApplicationMode: applicationMode,
      ApplicationDate: this.logFile.DataSet.Created,
      AdditionalValue: {
        DeadBiomass: json['DeadBiomass'] != null ? json['DeadBiomass'].split(' ')[0] : undefined,
        ExpectedYield: undefined,
        NMinPotential: undefined
      },
      FarmId: this.logFile.FarmId,
      Title: `${this.translationStore.FindTranslationForSelectedLanguage('Global__New_Planning')} ${dateString}`,
      Version: 0,
      UserApplicationConstant: standard,
      UserApplicationMaximum: json['Maximum'] ? +json['Maximum'] : this.logFile.NContentMax,
      UserApplicationMinimum: json['Minimum'] ? +json['Minimum'] : this.logFile.NContentMin,
      UserApplicationRate: applicationRate,
      Unit: this.unitStore.getUnit('kgN/ha'),
      Slope: 1,
    } as INFertilizationSummary;

    return {
      Id: undefined,
      ApplicationMode: applicationMode,
      Note: '',
      Summary: summary,
      ApplicationDate: this.logFile.DataSet.Created,
      FieldId: this.fieldStore.getFieldByFieldGeomId(this.logFile.FieldGeomId)?.Id,
      Status: 0,
      OperationMode: operationMode,
      ECValue: this.logFile.Ec,
      FieldGeomId: this.logFile.FieldGeomId,
      Area: this.logFile.Area,
      ApplicationConst: standard,
      ApplicationMax: json['Maximum'] ? +json['Maximum'] : this.logFile.NContentMax,
      ApplicationMin: json['Minimum'] ? +json['Minimum'] : this.logFile.NContentMin,
      ApplicationRate: applicationRate,
      Threshold: threshold,
      Version: 0,
      FarmId: this.logFile.FarmId,
      Element: 5,
      MainCropId: this.logFile.CropType,
      Geom: this.fieldStore.getFieldGeomById(this.logFile.FieldGeomId)?.Geom,
      Unit: this.unitStore.getUnit('kgN/ha'),
      Slope: 1,
      Factor: 1,
    } as INFertilizationPlanBook;
  }

  private _onFormValueChanges(control: string, _: any): void {
    if (!control || this.formValuesUpdateInProgress) {
      return;
    }

    const inputsToUpdate: { [key: string]: any } = {};
    const planningControlValue = this.dynForm?.form?.get('Planning')?.value;

    switch (control) {
      case 'Planning':
        if (planningControlValue) {
          inputsToUpdate['Product'] = planningControlValue.ProductId ?? '';
          inputsToUpdate['Group'] = planningControlValue.ProductId ? this.fertilizerStore.getGroup(planningControlValue.ProductId) : 0;
        }
        break;
      case 'Group':
        if (!inputsToUpdate.hasOwnProperty('Product')) {
          inputsToUpdate['Product'] = '';
        }
        break;
    }

    if (Object.keys(inputsToUpdate).length > 0) {
      this.formValuesUpdateInProgress = true;
      try {
        Object.keys(inputsToUpdate).forEach(val => {
            const c = this.dynForm.form.get(val);
            if (c !== null && c.value !== inputsToUpdate[val]) {
              c.setValue(inputsToUpdate[val]);
            }
          }
        );
      } catch {
      }

      this.formValuesUpdateInProgress = false;
    }
  }
}
